import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import Navbar2 from "../Components/Navbar2";
import TitansHero from "../Components/TitansHero";
import TitansNavbar from "../Components/TitansNavbar";
import Footer from "../Components/Footer";

export const TitansRecruitment = () => {
  const form = useRef();
  const [status, setStatus] = useState(''); // '', 'SUCCESS', or 'ERROR'
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_emb74ep', 'template_l2851ss', form.current, {
        publicKey: 'N0vvrG_zSfS9o_XPR',
      })
      .then(() => {
        setStatus('SUCCESS');
      })
      .catch((error) => {
        console.error('FAILED...', error.text);
        setStatus('ERROR');
      });
  };
  return (
    <>
      <Navbar2 />
      <TitansHero />
      <TitansNavbar />
      {/* Recruitment Form */}
      {status === 'SUCCESS' ? (
        <div className='container-fluid'>
          <div className='row'>
            <div className='col text-center'>
              <div className='titansTitle text-center pt-5 pb-3'>
          Become a Titan!
        </div>
              <p className="py-3 titansRedTitle">
                Thank you in your interest in <br/>becoming a Titans Player!
              </p>
                <p className='lead'>
                  We have received all your information from the Recruitment Form.
                  A staff member will be contacting you shortly.
                </p>
            </div>
          </div>
        </div>
      ) : (
      <div className="container-fluid">
        <div className='titansTitle text-center pt-5 pb-3'>
          Become a Titan!
        </div>
        <form ref={form} onSubmit={sendEmail} className="container">
          {/* Player Information */}
          <fieldset className="border rounded-3 p-3 mb-4">
            <legend className="float-none w-auto px-2 h5 mb-3">Player Information</legend>

            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="firstName" className="form-label">First Name *</label>
                <input type="text" className="form-control" id="firstName"
                  name="firstName" autoComplete="given-name"
                  required />
              </div>
              <div className="col-md-4">
                <label htmlFor="lastName" className="form-label">Last Name *</label>
                <input type="text" className="form-control" id="lastName" name="lastName" autoComplete="family-name" required />
              </div>

              <div className="col-md-3">
                <label htmlFor="dob" className="form-label">Date of Birth *</label>
                <input type="date" className="form-control" id="dob" name="dob" required />
              </div>

            <div className="col-md-4">
              <label htmlFor="heightFeet" className="form-label">Height *</label>
              <div className="input-group">
                <input type="number" className="form-control"
                  id="heightFeet" name="heightFeet"
                  placeholder="5" min="3" max="8"
                  required
                  />
                <span className="input-group-text">ft</span>
                <input type="number" className="form-control"
                  id="heightInches" name="heightInches"
                  placeholder="10" required 
                />
                <span className="input-group-text">in</span>
              </div>
            </div>

              <div className="col-md-4">
                <label htmlFor="weight" className="form-label">Weight *</label>
                <div className="input-group">
                  <input type="number" className="form-control" id="weight"
                    name="weight" placeholder="185"
                    required 
                  />
                  <span className="input-group-text">lbs</span>
                </div>
              </div>

              <div className="col-md-5">
                <label htmlFor="address" className="form-label">Address *</label>
                <input type="text" className="form-control" id="address"
                  name="address" autoComplete="address-line1"
                  placeholder="Street address" required
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="city" className="form-label">City *</label>
                <input type="text" className="form-control" id="city"
                  name="city" autoComplete="address-level2" required />
              </div>
              <div className="col-md-2">
                  <label htmlFor="state" className="form-label">State *</label>
                    <select id="state" name="state" className="form-select"
                      defaultValue=""
                      required>
                      <option value="" disabled>Choose...</option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </select>
                  <div className="invalid-feedback">Please select your state.</div>
                </div>
              <div className="col-md-2">
                <label htmlFor="zip" className="form-label">ZIP *</label>
                <input type="text" className="form-control" id="zip"
                  name="zip" inputMode="numeric" pattern="\d{5}(-\d{4})?"
                  placeholder="12345" required 
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="playerPhone" className="form-label">Phone Number *</label>
                <input type="tel" className="form-control"
                  id="playerPhone" name="playerPhone"
                  autoComplete="tel"
                  placeholder="(555) 555-5555"
                  required 
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="playerEmail" className="form-label">Email Address *</label>
                <input type="email" className="form-control"
                id="playerEmail" name="playerEmail"
                autoComplete="email"
                required />
              </div>
              <div className="col-md-6">
                <label htmlFor="teamLevel" className="form-label">Team: High School or Post Grad *</label>
                <select id="teamLevel" name="teamLevel" className="form-select"
                  defaultValue=""
                  required>
                  <option value="" disabled>Choose...</option>
                  <option value="High School">High School</option>
                  <option value="Post Grad">Post Grad</option>
                </select>
              </div>

              <div className="col-md-6">
                <label htmlFor="positions" className="form-label">Primary Position(s) *</label>
                <select id="positions" name="positions" className="form-select" multiple required aria-describedby="posHelp">
                  <option value="PG">Point Guard (PG)</option>
                  <option value="SG">Shooting Guard (SG)</option>
                  <option value="SF">Small Forward (SF)</option>
                  <option value="PF">Power Forward (PF)</option>
                  <option value="C">Center (C)</option>
                </select>
                <div id="posHelp" className="form-text">Hold Ctrl/Cmd to select multiple.</div>
              </div>

              <div className="col-md-4">
                <label htmlFor="gradYear" className="form-label">Graduation Year *</label>
                <select id="gradYear" name="gradYear" className="form-select" required>
                  <option value="" defaultValue disabled>Choose...</option>
                  <option>2025</option>
                  <option>2026</option>
                  <option>2027</option>
                  <option>2028</option>
                  <option>2029</option>
                  <option>2030</option>
                  <option>2031</option>
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor="school" className="form-label">Current / Previous School *</label>
                <input type="text" className="form-control" id="school" name="school" required />
              </div>

              <div className="col-md-4">
                <label htmlFor="club" className="form-label">AAU / Club Team / Coach Name</label>
                <input type="text" className="form-control" id="club" name="club" placeholder="Team name and coach" />
              </div>

              <div className="col-md-4">
                <label htmlFor="gpa" className="form-label">GPA / Academic Info</label>
                <div className="input-group">
                  <input type="number" className="form-control" id="gpa" name="gpa"
                    step="0.01" min="0" max="5" placeholder="e.g., 3.85" />
                  <span className="input-group-text">/ 4.0–5.0</span>
                </div>
              </div>

              <div className="col-md-4">
                <label htmlFor="ncaaId" className="form-label">NCAA Eligibility Center ID (if registered)</label>
                <input type="text" className="form-control" id="ncaaId" name="ncaaId" />
              </div>

              <div className="col-md-4">
                <label htmlFor="highlightLink" className="form-label">Highlight Video Link (YouTube / Hudl)</label>
                <input type="url" className="form-control" id="highlightLink" name="highlightLink" placeholder="https://" />
              </div>

              <div className="col-12">
                <label htmlFor="goals" className="form-label">Goals for Basketball &amp; College</label>
                <textarea className="form-control" id="goals" name="goals" rows="4" placeholder="Tell us about your goals"></textarea>
              </div>
            </div>
          </fieldset>

          {/* <!-- Parent / Guardian Information --> */}
          <fieldset className="border rounded-3 p-3 mb-4">
            <legend className="float-none w-auto px-2 h5 mb-3">Parent / Guardian Information</legend>

            <div className="row g-3">
              <div className="col-12">
                <label htmlFor="guardianNames" className="form-label">Parent / Guardian Name(s) *</label>
                <input type="text" className="form-control" id="guardianNames" name="guardianNames" required />
              </div>

              <div className="col-md-6">
                <label htmlFor="guardianPhone" className="form-label">Phone Number *</label>
                <input type="tel" className="form-control" id="guardianPhone" name="guardianPhone" autoComplete="tel" required />
              </div>
              <div className="col-md-6">
                <label htmlFor="guardianEmail" className="form-label">Email Address *</label>
                <input type="email" className="form-control" id="guardianEmail" name="guardianEmail" autoComplete="email" required />
              </div>

              <div className="col-md-6">
                <label htmlFor="relationship" className="form-label">Relationship to Student/Athlete *</label>
                <select id="relationship" name="relationship"
                  className="form-select"
                  defaultValue=""
                  required
                >
                  <option value="" disabled>Choose...</option>
                  <option>Mother</option>
                  <option>Father</option>
                  <option>Guardian</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
          </fieldset>

          {/* <!-- Additional Details --> */}
          <fieldset className="border rounded-3 p-3 mb-4">
            <legend className="float-none w-auto px-2 h5 mb-3">
              Additional Details
            </legend>
            <div className="mb-2">
              <h6 className="form-label d-block">How did you hear about ADS Prep? 
                <span className="text-muted">
                  (Select one)
                </span>
              </h6>
            </div>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-2">
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource" id="refInstagram" value="Instagram" />
                  <label className="form-check-label" htmlFor="refInstagram">Instagram</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource" id="refX" value="X (Twitter)"  />
                  <label className="form-check-label" htmlFor="refX">X (Twitter)</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource" id="refTikTok" value="TikTok"  />
                  <label className="form-check-label" htmlFor="refTikTok">TikTok</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource"
                    id="refCoach" value="Coach / Trainer"  />
                  <label className="form-check-label" htmlFor="refCoach">Coach / Trainer</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource"
                    id="refFamily" value="Family / Friend Referral"  />
                  <label className="form-check-label" htmlFor="refFamily">Family / Friend Referral</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource" id="refSchool" value="School Visit / Showcase" />
                  <label className="form-check-label" htmlFor="refSchool">School Visit / Showcase</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="refSource" id="refWeb" value="Website / Online Search" />
                  <label className="form-check-label" htmlFor="refWeb">Website / Online Search</label>
                </div>
              </div>
              <div className="col">
                <div className="form-check d-flex align-items-center gap-2">
                  <input className="form-check-input" type="radio" name="refSource" id="refOther" value="Other" />
                  <label className="form-check-label me-2" htmlFor="refOther">Other</label>
                  <input type="text" className="form-control form-control-sm" id="refOtherText" name="refOtherText" placeholder="Please specify" />
                </div>
              </div>
            </div>
          </fieldset>

          <div className="p-3 pb-5 text-center content">
            <button type="submit" value="Send">Submit My Application</button>
          </div>
        </form>
      </div>)}
      {status === 'ERROR' && (
        <p className="text-danger">Something went wrong. Please try again later.</p>
      )}
      <Footer />
    </>
  );
}

export default TitansRecruitment;
